module.exports = __webpack_public_path__ + "static/media/SDFSA_3-682w.68dc5fb0.jpg";